import {
	generateFilterPLU,
	isPatternByPLU,
} from './utils';

klevu.coreEvent.attach('setRemoteConfigLanding', {
	name: 'search-landing-product-plu',
	fire: function() {
		if (isPatternByPLU()) {
			klevu.search.landing.getScope().chains.request.build.addAfter('addProductList', {
				name: 'addFilterPLU',
				fire: function(data, scope) {
					const filters = data.localOverrides.query.productList.filters.applyFilters.filters || [];
					data.localOverrides.query.productList.filters.applyFilters.filters = generateFilterPLU(filters);
					data.request.current.recordQueries[0].settings.query.term = '';
				}
			});
		}
	}
});



// WEBPACK FOOTER //
// ./klevu/klevu-landing-filter-plu.js